import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { IconMobileHamburger } from '../Icons';

import { StyledButton } from './MobileHamburgerStyles';

var _ref = React.createElement(IconMobileHamburger, null);

var MobileHamburger = function MobileHamburger(props) {
  return ReactDOM.createPortal(React.createElement(
    StyledButton,
    {
      'aria-label': 'Open Nav',
      open: props.isNavOpen,
      onClick: props.toggleMobileNav
    },
    _ref
  ), document.getElementById('dormify-header__hamburger'));
};

MobileHamburger.propTypes = {
  toggleMobileNav: PropTypes.func.isRequired
};

export default MobileHamburger;